<template>
    <section class="content">


        <div class="card card-solid">
            <div class="card-body pb-0">

                <div class="card-header p-2">
                    <button type="button" class="btn btn-primary" data-toggle="modal"
                            data-target="#createFeedback">
                        Новый отзыв
                    </button>
                    <div class="text-muted" style="float: right">
                        Отзывов на странице:
                        <input type="number" step="1" min="1" :max="filteredData.length" v-model="size"
                               class="form-control" :placeholder="size">
                    </div>
                </div>

                <div v-if="pageCount > 0" class="card-header p-2">
                    <div class="container-fluid">
                        <div class="row">

<!--                            Пагинация-->
                            <div class="col-sm-12 col-md-4">
                                <div class="text-muted">
                                Страница {{currentPage}} из {{pageCount}}
                                </div>
                                <div class="btn-group" style="display: flex">
                                    <button class="btn btn-secondary" :disabled="pageNumber === 0" @click="prevPage">
                                        < Сюда
                                    </button>
                                    <button class="btn btn-secondary" :disabled="pageNumber >= pageCount -1" @click="nextPage">
                                        Туда >
                                    </button>
                                </div>
                            </div>

<!--                            Сортировка-->
                            <div class="col-sm-12 col-md-4">
                                <div class="title text-muted">
                                    <i :class="currentSortDir === 'asc' ? 'fa fa-arrow-down' : 'fa fa-arrow-up'"></i>
                                    Сортировать по:
                                </div>
                                <div class="btn-group btn-group-toggle" data-toggle="buttons" style="display: flex">
                                    <label class="btn btn-secondary active" v-on:click="sort('id')">
                                        <input type="radio" name="options" autocomplete="off" checked> Id
                                    </label>
                                    <label class="btn btn-secondary" v-on:click="sort('type')">
                                        <input type="radio" name="options" autocomplete="off"> Тип
                                    </label>
                                    <label class="btn btn-secondary" v-on:click="sort('status')">
                                        <input type="radio" name="options" autocomplete="off"> Статус
                                    </label>
                                    <label class="btn btn-secondary" v-on:click="sort('created_at')">
                                        <input type="radio" name="options" autocomplete="off"> Дата
                                    </label>
                                </div>
                            </div>

<!--                            Фильтр-->
                            <div class="col-sm-12 col-md-4">
                                <div class="title text-muted">
                                    Фильтр:
                                </div>
                                <div class="btn-group btn-group-toggle" data-toggle="buttons" style="display: flex">
                                    <label class="btn btn-secondary active" v-on:click="filter('All')">
                                        <input type="radio" name="options" autocomplete="off" checked> Все
                                    </label>
                                    <label v-for="uniqueUserType in uniqueUserTypes" class="btn btn-secondary" v-on:click="filter(uniqueUserType)">
                                        <input type="radio" name="options" autocomplete="off" checked> {{uniqueUserType}}
                                    </label>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

                <div class="row d-flex align-items-stretch">


<!--                    Карточка отзыва-->
                    <div v-for="feedback in paginatedData" class="col-12 col-sm-6 col-md-4 d-flex align-items-stretch">
                        <div :class="(feedback.isNew ? 'on-moder ' : ' ') + 'shadowed card bg-light w-100'">
                            <div class="card-header border-bottom-0 text-muted">
                                Id: {{feedback.id}}
                                <span v-if="feedback.isNew" class="badge badge-secondary"> На модерации </span>
                            </div>
                            <div class="card-body pt-0">
                                <div class="row full-height">
                                    <div class="col-12">
                                        <div>
                                            <p class="text-muted text-sm"><b>{{feedback.type}}</b></p>
                                            <ul class="ml-4 mb-0 fa-ul text-muted">
                                                <li class="small">
                                                    <a :href="'/admin/users/show?id=' + feedback.user.id">
                                                    <span class="fa-li"><i class="fas fa-lg fa-user"></i></span>
                                                        {{feedback.user.type}}: {{feedback.user.name}}
                                                    </a>
                                                </li>
                                                <li class="small"><span class="fa-li"><i
                                                        class="fas fa-lg fa-building"></i></span>{{feedback.user.corp}}
                                                </li>
                                                <li class="small"><span class="fa-li"><i
                                                        class="fas fa-lg fa-calendar"></i></span>{{feedback.created_at}}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="lead info-box feedback-text">
                                            <b class="w-100">
                                                <span v-html="feedback.text"></span>
                                            </b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="text-right">
                                    <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#editModal" v-on:click="openEditor(feedback)">
                                        <i class="fas fa-pen"></i>
                                        Изменить
                                    </button>
                                    <button class="btn btn-sm btn-secondary" v-on:click="remove(feedback)">
                                        <i class="fas fa-trash"></i>
                                        Удалить
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

<!--                Пагинация-->
                <div v-if="pageCount > 0" class="card-footer p-2">
                    <div class="col-sm-12 col-md-4">
                        <div class="text-muted">
                            Страница {{currentPage}} из {{pageCount}}
                        </div>
                        <div class="btn-group" style="display: flex">
                            <button class="btn btn-secondary" :disabled="pageNumber === 0" @click="prevPage">
                                < Сюда
                            </button>
                            <button class="btn btn-secondary" :disabled="pageNumber >= pageCount -1" @click="nextPage">
                                Туда >
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div>

<!--            Модальное окно для редактирования-->
            <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">
                                Тип: {{toEdit.type}}
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <editor
                                    placeholder="toEdit"
                                    v-model="toEdit.text"
                            ></editor>
                        </div>
                        <div class="modal-footer">
                            <button v-on:click="changeStatus(toEdit)" type="button" class="btn btn-primary">Изменить статус</button>
                            <button v-on:click="changeFeedback(toEdit)" type="button" class="btn btn-primary">Сохранить текст</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

<!--        Модальный компонент для создания-->
        <feedback-modal-component/>

    </section>
</template>

<script>

    import FeedbacksService from '../services/FeedbacksService';
    import FeedbackModalComponent from './FeedbackModalComponent';

    import Editor from '@tinymce/tinymce-vue';

    const COMPONENT_NAME = 'feedbacks';

    export default {
        name: COMPONENT_NAME,
        components: {
            FeedbackModalComponent,
            "editor": Editor
        },
        props: {
            size:{
                type:Number,
                required:false,
                default: 9
            }
        },
        data() {
            return {
                pageNumber: 0,
                pagesQty: 0,
                currentPage: 1,
                currentSort: 'id',
                currentSortDir: 'asc',
                selectedUserType: 'All',
                feedbacks: [],
                toEdit: [],
            };
        },
        mounted() {
            this.getFeedbacks();
        },
        computed:{
            sortedData:function() {
                return this.feedbacks.sort((a,b) => {
                    let modifier = 1;
                    if(this.currentSortDir === 'desc') modifier = -1;
                    if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if(a[this.currentSort] > b[this.currentSort]) return modifier;
                    return 0;
                });
            },
            pageCount(){
                let l = this.filteredData.length,
                    s = this.size;
                return Math.ceil(l/s);
            },
            paginatedData(){
                const start = this.pageNumber * this.size,
                    end = start + this.size;
                return this.filteredData
                    .slice(start, end);
            },
            filteredData: function() {
                const type = this.selectedUserType;

                if(type === "All") {
                    return this.sortedData;
                } else {
                    return this.sortedData.filter(function(feedback) {
                        return feedback.user.type === type;
                    });
                }
            },
            uniqueUserTypes: function () {
                return [...new Set(this.feedbacks.map(item => item.user.type))];
            }
        },
        methods: {
            filter: function(filter) {
                this.selectedUserType = filter;
            },
            sort:function(sort) {
                if(sort === this.currentSort) {
                    this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
                }
                this.currentSort = sort;
            },
            nextPage(){
                this.pageNumber++;
                this.currentPage++
            },
            prevPage(){
                this.pageNumber--;
                this.currentPage--;
            },
            async renderView() {
                this.getFeedbacks();
            },
            async getFeedbacks() {
                let response = await FeedbacksService.getFeebacks();
                if (response.success) {
                    this.feedbacks = response.feedbacks;
                }
            },
            async remove(feedback) {
                if (feedback) {
                    if (confirm('Точно удалить этот отзыв?\nПользователь: ' + feedback.user.name + '\nНаписал: ' + feedback.text)) {
                        let response = await FeedbacksService.remove(feedback.id);
                        if (response.success) {
                            this.feedbacks.splice(this.feedbacks.indexOf(feedback), 1);

                            this.$notify({message: 'Отзыв удален!', type: 'success'});
                        }
                    }
                }
            },
            async openEditor(feedback) {
                this.toEdit = feedback;
            },
            async changeFeedback(toEdit) {
                let response = await FeedbacksService.changeFeedback(toEdit);
                if (response.success) {
                    this.$notify({message: 'Отзыв сохранен!', type: 'success'});
                    this.renderView();
                }
            },
            async changeStatus(toEdit) {
                if (confirm('Точно сменить статус?')) {
                    let response = await FeedbacksService.changeStatus(toEdit.id);
                    if (response.success) {
                        this.$notify({message: 'Статус изменен', type: 'success'});
                        this.renderView();
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

    .form-control {
        width: auto;
        float: right;
    }

    .feedback-text {
        margin-top: 20px;
    }

    .on-moder {
        background-color: #c9e9ff!important;
    }

    .shadowed {
        &:hover {
            box-shadow: 0 0 10px rgba(0,0,0,0.5);
            transition: all .25s ease;
        }
    }

    .sort-by {
        display: inline-flex;
        .title {
            align-self: center;
            padding-right: 10px;
        }
    }

</style>